import React from 'react';

export type TabType = 'home' | 'instrument' | 'faq' | 'contact';

interface TabNavigationProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const TABS: { id: TabType; label: string }[] = [
  { id: 'instrument', label: 'Instrument Review' },
  { id: 'home', label: 'Take Survey' },
  { id: 'faq', label: 'FAQ' },
  { id: 'contact', label: 'Contact' },
];

const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex space-x-6">
      {TABS.map(({ id, label }) => (
        <button
          key={id}
          className={`font-medium text-sm transition-colors ${
            activeTab === id ? 'text-primary-600' : 'text-gray-600 hover:text-gray-900'
          }`}
          onClick={() => onTabChange(id)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
